import NewLayout from "@components/new-ui/Layout";
import { FC, Key, ReactChild, ReactFragment, ReactPortal } from "react";
import CtaBlock from "./Bot-template/CTABlock";
import RelatedIndustries from "./Bot-template/RelatedIndustriesBlock";
import BotTemplateCard from "./Bot-template/bot-template-card";
import { BotTemplatePageResult, RelatedTemplateData } from "types/wa-chatbot-templates";

interface BotTemplatePageType {
    data: BotTemplatePageResult;
}
const BotTemplatePage: FC<BotTemplatePageType> = ({ data }) => {
    const keyFeatures = data?.res.features;

    const NAV = ["all templates", data?.res.category?.toLowerCase(), data?.res.title?.toLowerCase()];
    const categoryName = data?.res.category?.toLowerCase()?.split(" ")?.join("-");

    const breadCrumb = [
        {
            name: "all templates",
            link: "/whatsapp-chatbot-templates",
        },
        {
            name: data?.res.category?.toLowerCase(),
            link: `/whatsapp-chatbot-templates/${categoryName}`,
        },
        {
            name: data?.res.title?.toLowerCase(),
            link: "#",
        },
    ];
    return (
        <NewLayout
            title={data?.res.metaTitle ? data?.res?.metaTitle : "Gallabox WhatsApp Chatbot | Multiply your conversions by 2X with our No-Code Chatbot"}
            description={
                data?.res.metaDescription
                    ? data?.res.metaDescription
                    : "Never miss out on a lead ever again with Gallabox's WhatsApp chatbot. Build your bot in a few minutes, get started now!"
            }
            canonical={`https://gallabox.com/whatsapp-chatbot-templates/${categoryName}/${data?.slug?.[0]}/${data?.slug?.[1]}`}
        >
            <div className="bot-template-page lg:w-5/6 mx-auto mb-16 px-5 lg:px-0">
                <header className="lg:mt-24 flex max-w-6xl mx-auto flex-col lg:flex-row justify-between items-center lg:gap-20 bot-template-page-header py-5">
                    <div className="basis-1/2 flex justify-center items-center">
                        <div>
                            <nav>
                                <ul className="list-none flex p-0">
                                    {breadCrumb?.map((nav, i) => (
                                        <a href={nav.link} key={nav.name} style={{ textDecoration: "none" }}>
                                            <li>
                                                {nav.name} {!(NAV.length - 1 === i) && <span className="mx-1">{">"}</span>}{" "}
                                            </li>
                                        </a>
                                    ))}
                                </ul>
                            </nav>
                            <h1 className="header m-0 mt-3">{data?.res.title}</h1>
                            <div>
                                <p className="description mt-2.5 mb-2 text-center md:text-left md:w-9/12">{data?.res?.description} </p>
                                <button className="tag mb-5 w-fit">{data?.res?.tags[0].name}</button>
                            </div>
                            <a className="btn" href={`https://wa.me/917825875225?text=${encodeURIComponent("I want to try " + data?.res?.title)}`}>
                                Try on WhatsApp
                            </a>
                        </div>
                    </div>
                    <div className="basis-1/2 my-10 lg:my-0">
                        <img src="https://assets.gallabox.com/gb-home/bot-templates/bot-template-head-img-new.svg" alt="Bot template header image" />
                    </div>
                </header>
                <section className="flex flex-col lg:flex-row max-w-6xl mx-auto justify-start lg:mt-28 bot-template-main gap-3">
                    <div className="">
                        <main className="w-full lg:w-3/4">
                            <div className="w-full lg:w-5/6">
                                <h2 className="title m-0 mb-6">About {data?.res?.title}</h2>
                                <p className="description">{data?.res?.longDescription?.markdownText}</p>
                            </div>
                            <div className="bot-template-features mt-5 lg:mt-36">
                                <h2 className="category-title">Key Features</h2>
                                <ul className="grid lg:grid-rows-2  lg:grid-cols-2  lg:gap-x-0 lg:gap-y-1 gap-1 lg:gap-0 list-none p-0 mt-4 ">
                                    {keyFeatures?.map((each: boolean | ReactChild | ReactFragment | ReactPortal | null | undefined, i: Key | null | undefined) => {
                                        return (
                                            <li key={i} className="p-0 flex items-start  gap-2">
                                                <span className="mt-1.5">
                                                    <img src="https://assets.gallabox.com/gb-home/bot-templates/icons/blue-tick.png" alt="Blue Checkmark" />
                                                </span>
                                                <span className="w-full lg:w-4/5 content">{each}</span>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </main>
                    </div>
                </section>
            </div>

            <CtaBlock
                textContent="Automate your customer conversations with Gallabox Chatbot to scale your business."
                img="https://assets.gallabox.com/gb-home/case-study/Robot.png"
            />
            <RelatedIndustries industryData={data?.categories} />
            <div className="bot-template-collection-bottom-section w-full mx-auto lg:mt-24  lg:w-5/6 px-5 lg:px-0">
                <section>
                    <div className="max-w-6xl mx-auto">
                        <h2 className="category-title mb-6 mt-10 lg:mt-20">Related Templates</h2>
                        <div className="flex flex-col lg:flex-row gap-5">
                            {data.relatedData.map((item: RelatedTemplateData, i: number) => {
                                if (i < 3) {
                                    return (
                                        <BotTemplateCard
                                            key={item._id}
                                            name={item.title}
                                            id={item._id}
                                            title={item.title}
                                            description={item.description}
                                            count={item.usedCount}
                                            tag={item.tags}
                                            image={item.picture}
                                            category={item.category}
                                        />
                                    );
                                }

                                return null;
                            })}
                        </div>
                    </div>
                </section>
            </div>
        </NewLayout>
    );
};

export default BotTemplatePage;
